export default {
  price: '价格',
  typeStr: '项目类型',
  typeStr2: '数据类型',
  duration: '周期',
  day: '天',
  examine: '审核',
  mytask: '我的任务',
  makemoney: '领取任务',
  goTask: '继续任务',
  description: '项目描述',
  requirement: '项目要求',
  projectNo: '你好像暂时不能申请该项目。',
  return: '返回项目列表',
  taskmanage: '项目管理',
  report: '报表',
  limitmanage: '权限管理',
  brief: '项目简介',
  dectask: '项目背景描述',
  rule: '标注规则',
  effective: '有效性判断准则',
  qualified: '合格标准',
  releaseTime: '发布时间：',
  detail: '项目详情',
  skill: '技能要求',
  do: '做任务',
  project0:	'质检层',
  project1:	'任务列表',
  project2:	'开始质检',
  project3:	'提示',
  project4:	'做任务需先获取对应技能勋章',
  project5:	'获取技能勋章'
}



// WEBPACK FOOTER //
// ./src/lang/zh/project.js